import { PartCostOverrideOptionsProvider_PropertyValueOption } from "src/api/generated/erp/sales/partCostOverride/partCostOverrideOptionsProvider.ts";
import { PartCostOverrideConditions_Condition } from "src/api/generated/io/aavo/applications/db/erp/types/partCostOverrideConditions.ts";

export interface PartCostOverrideConditionOptions {
	propertyNames: string[];
	valuesByPropertyName: Record<string, PartCostOverrideOptionsProvider_PropertyValueOption[]>;
}

/**
 * Groups the property values found in the document's configurations by property name. Values of existing conditions
 * stay selectable even when no configuration currently has them.
 */
export function getPartCostOverrideConditionOptions(
	valueOptions: PartCostOverrideOptionsProvider_PropertyValueOption[],
	existingConditions: PartCostOverrideConditions_Condition[],
): PartCostOverrideConditionOptions {
	const valuesByPropertyName: Record<string, PartCostOverrideOptionsProvider_PropertyValueOption[]> = {};
	const addOption = (option: PartCostOverrideOptionsProvider_PropertyValueOption) => {
		const values = (valuesByPropertyName[option.propertyName] ??= []);
		if (!values.some((value) => value.propertyValue === option.propertyValue)) values.push(option);
	};

	valueOptions.forEach(addOption);
	existingConditions.forEach((condition) =>
		addOption({
			propertyName: condition.propertyName,
			propertyValue: condition.propertyValue,
			label: condition.propertyValue,
		}),
	);

	return {
		propertyNames: Object.keys(valuesByPropertyName).sort((a, b) => a.localeCompare(b)),
		valuesByPropertyName,
	};
}
